<template>
    <div class="h-full">
        <Teleport to="body">
            <transition name="fade">
                <div v-show="modalActive" @click.self="closeModal" @keydown.esc="closeModal"
                    class="bg-black/20 backdrop-blur z-50 fixed top-0 left-0 h-full w-full flex  justify-center animate-in fade-in duration-300 items-center py-8 overflow-y-scroll overflow-x-hidden scrollbar-hide js_close_clickable">
                    <transition name="fade">
                        <div v-show="modalActive" class="w-full h-full flex flex-col justify-center items-center"
                            @click.self="closeModal">
                            <div v-if="$attrs.showHeader"
                                class="bg-white dark:bg-neutral-800 flex flex-col gap-2 rounded-md shadow-xl animate-in fade-in zoom-in w-full max-w-screen-md w-full">
                                <div v-if="$attrs.showHeader"
                                    class="relative py-6 flex justify-center items-center dark:text-white border-b border-gray-400 dark:border-neutral-700">
                                    <div class="absolute left-4 top-4 p-2 hover:bg-gray-300 dark:hover:bg-neutral-700 rounded-full cursor-pointer"
                                        @click="closeModal">
                                        <svg xmlns="http://www.w3.org/2000/svg" class="w-6 h-6" fill="currentColor"
                                            viewBox="0 0 384 512"><!--!Font Awesome Free 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.-->
                                            <path
                                                d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z" />
                                        </svg>
                                    </div>
                                    <div class="font-bold">
                                        {{ $attrs.headerText }}
                                    </div>
                                </div>
                            </div>
                            <slot name="modal_content"></slot>
                        </div>
                    </transition>
                </div>
            </transition>
        </Teleport>

        <button type="button" @click="open" class="h-full w-full" aria-label="Open modal">
            <slot name="modal_button">Click here</slot>
        </button>
    </div>
</template>
  
<script>
export default {
    data() {
        return {
            modalActive: false,
        }
    },

    methods: {
        open() {
            $("body").addClass("scroll_lock")
            this.modalActive = true;
        },
        closeModal() {
            this.modalActive = false;
            setTimeout(function () {
                $("body").removeClass("scroll_lock")
            }, 200);
        }
    }
};
</script>